import { useQueryWithUserId } from '@northladder/services';

import { APP_CONFIG_API } from '../appConfigApiClient';

/**
 * Cache Date: This is added to the query key
 * to force a refetch when the cache date changes.
 */
const cacheDate = new Date().getTime();

/**
 * Query App Configurations
 */
const APP_CONFIG_QUERY = 'app-config-query';

export const useGetAppConfigurationQuery = () => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [APP_CONFIG_QUERY, cacheDate],
    retry: false,
    queryFn: () => APP_CONFIG_API.fetchAppConfigurations(),
    staleTime: 0,
    gcTime: 0,
  });

  return {
    data,
    isError,
    error,
    isPending,
    refetch,
  };
};
